<template>
  <div class="d-flex align-center justify-center">
    <v-progress-circular
        :rotate="180"
        :size="131"
        :width="10"
        :value="bidBasicProgress"
        color="teal darken-3"
    >
    </v-progress-circular>
    <v-progress-circular
        :rotate="180"
        :size="106"
        :width="10"
        :value="headDepartmentBasicProgress"
        :color="isHeadDepartment ? '#f2711c' : 'error'"
        class="position-absolute"
    >
    </v-progress-circular>
    <v-progress-circular
        :rotate="180"
        :size="80"
        :width="10"
        :value="deanBasicProgress"
        :color="isDean ? 'blue darken-1' : 'error'"
        class="position-absolute"
    >
      <the-deciphering-progress-contract
        :bid-basic-progress="bidBasicProgress"
        :head-department-basic-progress="headDepartmentBasicProgress"
        :dean-basic-progress="deanBasicProgress"
      />
    </v-progress-circular>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import TheDecipheringProgressContract from "./TheDecipheringProgressContract.vue";

export default {
  name: "TheCircleProgressContract",

  components: {TheDecipheringProgressContract},

  props: {
    bidBasicProgress: Number,
    headDepartmentBasicProgress: Number,
    deanBasicProgress: Number,
  },

  computed: {
    ...mapGetters({
      isDean: "effective_contract/isDean",
      isHeadDepartment: "effective_contract/isHeadDepartment",
    }),
  },
}
</script>

<style scoped>
.position-absolute {
  position: absolute;
}
</style>